<div #textContainer style="--font-size:{{initialFontSize}}px;font-size:var(--font-size);">
  <ng-content></ng-content>
</div>
